import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-mobile-web',
  templateUrl: './mobile-web.page.html',
  styleUrls: ['./mobile-web.page.scss'],
})
export class MobileWebPage {

  marketid;

  constructor(
    private modalCtrl: ModalController, 
    private generalService: GeneralService
  ) { }

  close() {
    this.modalCtrl.dismiss()
  }

  openUrl() {
    this.generalService.openUrl('https://altomate.page.link/ezHe')
  }

}
